// Chakra Imports
// Custom Icons
import React from "react";

import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { connect } from "react-redux";
import { switchThemeMode } from '../../redux/layout/layoutState';

const FixedPlugin = ({defaultMode, ...rest}) => {
  //const { ...rest } = props;
  const [darkmode, setDarkmode] = React.useState(defaultMode);

  return (
    <button
      className="border-px fixed bottom-[30px] right-[35px] !z-[99] flex h-[30px] w-[30px] items-center justify-center rounded-full border-[#6a53ff] bg-gradient-to-br from-brandSecondary to-brandLinear p-0"
      onClick={() => {
        if (darkmode) {
          document.body.classList.remove("dark");
          setDarkmode(false);
          switchThemeMode(false);
        } else {
          document.body.classList.add("dark");
          setDarkmode(true);
          switchThemeMode(true);
        }
      }}
      {...rest}
    >
      {/* // left={document.documentElement.dir === "rtl" ? "35px" : ""}
      // right={document.documentElement.dir === "rtl" ? "" : "35px"} */}
      <div className="cursor-pointer text-gray-600">
        {darkmode ? (
          <RiSunFill className="h-4 w-4 text-brand-accent" />
        ) : (
          <RiMoonFill className="h-4 w-4 text-brand-accent" />
        )}
      </div>
    </button>
  );
}

const mapStateToProps = (state) => ({
  	defaultMode: state.layout?.darkMode,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(FixedPlugin);
